import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { getCompanyTypes } from "store/state/companies";
import {
  Fade,
  FormHelperText,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper
} from "@material-ui/core";
import styled from "styled-components";
import { CompanyFormContext } from "./CompanyForm";

const CompanyCheckboxLabel = styled(FormControlLabel)`
  && {
    width: 238px;
    height: 40px;
  }
`;

export class CompanyCheckboxes extends Component {
  state = {
    companyId: null,
    selectableCompanyTypes: [],
    error: {
      atLeastOneRequired: false
    }
  };

  componentDidMount() {
    this.props.getCompanyTypes();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { company, companyTypes } = this.props;
    const { companyId } = prevState;
    if (this.shouldRenderDifferentCompany(companyTypes, companyId, company)) {
      const newtypes = this.createSelectableCompanyTypes(
        companyTypes,
        company.companyTypes
      );
      this.setState({
        companyId: company.id,
        isLoaded: true,
        selectableCompanyTypes: newtypes
      });
    }
  }

  shouldRenderDifferentCompany = (companyTypes, companyId, company) =>
    companyTypes && companyTypes.length > 0 && companyId !== company.id;

  createSelectableCompanyTypes = (allCompanyTypes, companyTypes) =>
    allCompanyTypes.map(el => {
      const checked = companyTypes.findIndex(x => x === el.id) > -1;
      return {
        ...el,
        checked
      };
    });

  copyCompanyType = (copiedCompanyTypes, companyTypeIndex) => {
    const previousCompanyType = copiedCompanyTypes[companyTypeIndex];
    return {
      ...previousCompanyType
    };
  };

  toggleCompanyType = (copiedCompanyTypes, name) => {
    const companyTypeIndex = copiedCompanyTypes.findIndex(x => x.name === name);
    const companyTypeCopy = this.copyCompanyType(
      copiedCompanyTypes,
      companyTypeIndex
    );
    companyTypeCopy.checked = !companyTypeCopy.checked;
    copiedCompanyTypes[companyTypeIndex] = companyTypeCopy;
  };

  validate = companyTypes => {
    const newError = {
      atLeastOneRequired: false
    };
    if (companyTypes.filter(x => x.checked).length === 0) {
      newError.atLeastOneRequired = true;
    }
    this.setState({
      error: newError
    });
  };

  // update internal state as well as provide new data to container CompanyForm
  handleChange = name => {
    const copiedCompanyTypes = [...this.state.selectableCompanyTypes];
    this.toggleCompanyType(copiedCompanyTypes, name);
    this.setState({
      selectableCompanyTypes: copiedCompanyTypes
    });
    this.props.setCompanyTypes(copiedCompanyTypes);
    this.validate(copiedCompanyTypes);
  };

  createCheckboxes = companyTypes =>
    companyTypes
      .sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      })
      .map(el => (
        <CompanyCheckboxLabel
          key={el.name}
          control={
            <Checkbox
              color="primary"
              checked={el.checked}
              onChange={() => this.handleChange(el.name)}
              value={el.name}
            />
          }
          label={el.name}
        />
      ));

  createCheckBoxErrors = () => {
    const { error } = this.state;
    if (error.atLeastOneRequired)
      return (
        <FormHelperText>At least one company type is required.</FormHelperText>
      );
    return (
      <CompanyFormContext.Consumer>
        {context => {
          if (context)
            return (
              <FormHelperText style={{ color: "red" }}>
                At least one company type is required.
              </FormHelperText>
            );
          return null;
        }}
      </CompanyFormContext.Consumer>
    );
  };

  createPlaceholderDiv = () => <div style={{ width: 600, height: 100 }} />;

  render() {
    const { selectableCompanyTypes, isLoaded, error } = this.state;
    const checkboxes = this.createCheckboxes(selectableCompanyTypes);

    if (!isLoaded) {
      return this.createPlaceholderDiv();
    }

    return (
      <Fragment>
        <Fade in={isLoaded}>
          <Paper elevation={4}>
            <div style={{ color: "#999cad", marginBottom: "16px" }}>
              Company Type(s)
            </div>
            <FormControl required error={error.atLeastOneRequired}>
              <FormGroup row>{checkboxes}</FormGroup>
              {this.createCheckBoxErrors()}
            </FormControl>
          </Paper>
        </Fade>
      </Fragment>
    );
  }
}

CompanyCheckboxes.propTypes = {
  company: PropTypes.object,
  setCompanyTypes: PropTypes.func.isRequired,
  getCompanyTypes: PropTypes.func.isRequired
};

const mapStateToProps = ({ authentication, companies }) => ({
  authentication,
  companyTypes: companies.companyTypes
});

export default compose(
  connect(
    mapStateToProps,
    { getCompanyTypes }
  )
)(CompanyCheckboxes);
